angular.module('bbl.directives.ng-modal', [])
.directive('ngModal', ['$parse', 'modals', '$timeout', function($parse, modals, $timeout) {
	return {
		restrict: 'EA',
		link: function($scope, $el, atts) {
			var $mScope = $scope.$new();
			$mScope.data = $parse(atts.ngData)($scope);

			$el.bind('click', function($event) {
				$event.preventDefault();
				$timeout(function() {
					modals.show(atts.ngModal+'-template.html', $mScope).modal();
				});
			});
		}
	};
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/ng-modal.js
 ** module id = 171
 ** module chunks = 0
 **/